import React from 'react';
import { motion } from 'framer-motion';
import { FaSearch, FaPenNib, FaRocket, FaFileAlt } from 'react-icons/fa';

const HowItWorks = () => {
    const steps = [
        {
            title: "Audit (15 min)",
            desc: "Kratak poziv da vidimo tvoj trenutni sistem i ciljeve.",
            icon: FaSearch
        },
        {
            title: "Build & Test (7-14 dana)",
            desc: "Kreiramo chatbota, ubacujemo tvoje podatke i testiramo scenarije.",
            icon: FaPenNib
        },
        {
            title: "Launch & Optimizacija",
            desc: "Puštamo chatbota u rad i pratimo performanse u realnom vremenu.",
            icon: FaRocket
        }
    ];

    return (
        <section id="proces" className="py-20 bg-black">
            <div className="max-w-6xl mx-auto px-4">
                <motion.div
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    viewport={{ once: true }}
                    className="text-center mb-20"
                >
                    <h2 className="text-3xl md:text-5xl font-bold mb-6">Jednostavno do rezultata.</h2>
                    <p className="text-gray-400 text-lg max-w-2xl mx-auto">Tvoj put od pretrpanog inboxa do automatizovane prodavnice koja radi sama.</p>
                </motion.div>

                <div className="relative">
                    {/* Connector Line */}
                    <div className="hidden md:block absolute top-1/2 left-0 w-full h-px bg-white/10 -translate-y-1/2" />

                    <div className="grid md:grid-cols-3 gap-12 relative">
                        {steps.map((step, idx) => (
                            <motion.div
                                key={idx}
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ delay: idx * 0.2 }}
                                className="relative z-10 bg-gray-900/50 p-8 rounded-3xl border border-white/5 text-center group backdrop-blur-sm"
                            >
                                <div className="w-16 h-16 bg-white/5 group-hover:bg-blue-600/20 rounded-2xl flex items-center justify-center mb-6 mx-auto transition-colors border border-white/5">
                                    <step.icon className="w-8 h-8 text-blue-400" />
                                </div>
                                <h3 className="text-xl font-bold mb-3">{step.title}</h3>
                                <p className="text-gray-400 leading-relaxed">{step.desc}</p>
                            </motion.div>
                        ))}
                    </div>
                </div>

                <motion.div
                    initial={{ opacity: 0, scale: 0.95 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    viewport={{ once: true }}
                    className="mt-20 p-8 rounded-3xl bg-white/5 border border-white/10 flex flex-col md:flex-row items-center gap-8 backdrop-blur-sm"
                >
                    <div className="bg-blue-600/20 p-4 rounded-2xl">
                        <FaFileAlt className="w-12 h-12 text-blue-400" />
                    </div>
                    <div>
                        <h4 className="text-xl font-bold mb-2 text-white">Šta nam treba od tebe?</h4>
                        <p className="text-gray-400">Da bismo počeli, potrebni su nam FAQ (česta pitanja), politika dostave/povrata i link do kataloga proizvoda.</p>
                    </div>
                </motion.div>
            </div>
        </section>
    );
};

export default HowItWorks;
